import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Link } from "react-router-dom";
import cn from "classnames";

import Modal from "../../../components/Modal";
import { amazonHost } from "../../../paths";
import routing from "../../../routing";

import { StyledPromoModal, UI } from "./styles";

import messages from "./messages";
import { IProps } from "./interfaces";

const largeLocales = ["el", "ro", "et", "lt"];

const PromoModal = ({ close }: IProps) => {
    const { locale } = useIntl();
    return (
        <Modal close={close} width={660 - 48} noScrollReturn>
            <StyledPromoModal>
                <img
                    src={amazonHost + `landing/promo${window.innerWidth < 500 ? "-mobile" : ""}.jpg`}
                    alt="happy teacher and children"
                ></img>
                <UI>
                    <h2>
                        <FormattedMessage {...messages.h2} />
                    </h2>
                    <p>
                        <FormattedMessage {...messages.p} />
                    </p>
                    <div className={cn({ fullButtons: largeLocales.includes(locale) })}>
                        <Link to={`/${routing.signup}`} className="button">
                            <span>
                                <FormattedMessage {...messages.action} />
                            </span>
                        </Link>
                        <Link to="/" className="button button--light">
                            <FormattedMessage {...messages.moreInfo} />
                        </Link>
                    </div>
                    {!largeLocales.includes(locale) && (
                        <div>
                            <FormattedMessage {...messages.trusty} />
                        </div>
                    )}
                </UI>
            </StyledPromoModal>
        </Modal>
    );
}

export default PromoModal;
